// ============ كتابة خفيفة في Firestore من غير مكتبة Firebase ============
// الموقع العام بيبعت الليدز والإحصائيات عن طريق REST (fetch) عشان ميتقلش بمكتبة Firebase كاملة.
// مكتبة Firebase بتتحمّل بس في صفحة الداشبورد.
import { FIREBASE_CONFIG, TIME_ZONE } from "../Data/firebaseConfig";

const DB = () => `projects/${FIREBASE_CONFIG.projectId}/databases/(default)/documents`;

// قيمة JS => قيمة Firestore REST
export const toValue = (v) => {
  if (v === null || v === undefined) return { nullValue: null };
  if (typeof v === "boolean") return { booleanValue: v };
  if (typeof v === "number") return Number.isInteger(v) ? { integerValue: String(v) } : { doubleValue: v };
  if (typeof v === "object") return { mapValue: { fields: toFields(v) } };
  return { stringValue: String(v) };
};
export const toFields = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined).map(([k, v]) => [k, toValue(v)]));

export const docName = (path) => `${DB()}/${path}`;

// يوم دبي بصيغة 2026-10-17 (اسم مستند الإحصائيات)
export const dubaiDay = (d = new Date()) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit" }).format(d);

// زيادة عدادات يوم معيّن: { sessions: 1, "pages.home": 1, ... }
export const statsWrite = (incs, day = dubaiDay()) => ({
  update: { name: docName(`stats/${day}`), fields: { date: { stringValue: day } } },
  updateMask: { fieldPaths: ["date"] },
  updateTransforms: Object.entries(incs)
    .filter(([, n]) => n)
    .map(([fieldPath, n]) => ({ fieldPath, increment: { integerValue: String(Math.round(n)) } })),
});

// إرسال مجموعة كتابات مرة واحدة. keepalive = يكمل حتى لو الزائر قفل الصفحة
export const commit = (writes, { keepalive = false } = {}) =>
  fetch(
    `https://firestore.googleapis.com/v1/${DB()}:commit?key=${encodeURIComponent(FIREBASE_CONFIG.apiKey)}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ writes }),
      keepalive,
    }
  ).then((r) => {
    if (!r.ok) throw new Error(`Firestore ${r.status}`);
    return r;
  });

export const randomId = (n = 20) => {
  const abc = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const bytes = new Uint8Array(n);
  (window.crypto || window.msCrypto).getRandomValues(bytes);
  return Array.from(bytes, (b) => abc[b % abc.length]).join("");
};

// مفتاح آمن لاسم حقل في Firestore: /developers/emaar => developers_emaar
export const keyOf = (s, fallback = "other") => {
  const k = String(s || "")
    .toLowerCase()
    .replace(/^\/+|\/+$/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 60);
  if (!k) return fallback;
  return /^[a-z_]/.test(k) ? k : `p_${k}`;
};
